import React from "react";
import { withApollo, type WithApolloClient } from "@apollo/client/react/hoc";
import { Modal } from "react-bootstrap";
import { accountTypesToEnglishMapping } from "statics/accountTypes";

import Button from "components/Button";
import IconHeader from "components/IconHeader";
import IconSubheader from "components/IconSubheader";

import "./RolloverInstructionsModal.scss";
import "./IndividualOverview.scss";

interface OwnProps {
  onClose?: () => void;
  onSuccess?: () => void;
  show?: boolean;

  accountNumber?: string;
  accountType?: string;
  hasCheckFundsTransfer?: boolean;
  accounts?: unknown[];
  auth0AccountSessionId?: string;
  isMultiAccount?: boolean;
}

type Props = WithApolloClient<OwnProps>;

class PaychexRolloverInstructionsModal extends React.PureComponent<Props> {
  _promises: Promise<unknown>[] = [];

  constructor(props: Props) {
    super(props);
  }

  getCheckTransferAddress = () => {
    const steps = [
      {
        id: 1,
        content:
          "Verify your account number is written in the memo field of your rollover check. If not present, write it in manually.",
      },
      {
        id: 2,
        content:
          "If your account information is not pre-printed on the check, hand-write it clearly on the check before mailing.",
      },
      {
        id: 3,
        content: "Mail your completed check to the address below.",
      },
    ];

    console.log(this.props.accountNumber, "accountNumber-modal");
    console.log(this.props.accountType, "accountType-modal");

    return (
      <div>
        <div className="important-notice">
          <div className="notice-title">
            <span className="notice-icon">⚠️</span>
            Important: Check your account number
          </div>
          <p className="notice-text">
            Before mailing your check, verify that your account number is
            written in the <span className="highlight">memo field</span>.
            Paychex should have included this, but if it&apos;s missing, please
            write your account number in the memo field yourself.
          </p>
        </div>

        <div className="section">
          <p className="section-title">Instructions:</p>
          <ol className="step-list">
            {steps.map((step) => (
              <li key={step.id} className="step-item">
                <span className="step-number">{step.id}.</span>
                <span className="step-text">{step.content}</span>
              </li>
            ))}
          </ol>
        </div>

        <div className="section">
          <p className="section-title">Your Account Number:</p>
          <div className="account-display">
            <div className="account-number">
              {
                accountTypesToEnglishMapping[
                  this.props
                    .accountType as keyof typeof accountTypesToEnglishMapping
                ]
              }
              : {this.props.accountNumber}
            </div>
          </div>
        </div>

        <div className="section">
          <p className="section-title">Mailing Address:</p>
          <div className="address-block">
            <div className="address-line">Attn: Banking Department</div>
            <div className="address-line">Apex Fintech Solutions</div>
            <div className="address-line">
              350 North St. Paul Street, STE 1300
            </div>
            <div className="address-line">Dallas, Texas 75201</div>
          </div>
        </div>
      </div>
    );
  };

  render() {
    const content = this.getCheckTransferAddress();

    if (this.props.show) {
      return (
        <Modal
          // @ts-expect-error PRESERVED BUG (conversion-only): "md" is not a valid react-bootstrap Modal size ("sm" | "lg" | "xl"); inert at runtime, kept verbatim
          size="md"
          centered
          scrollable
          show={this.props.show}
          className="rollover-modal"
        >
          <Modal.Header className="modal-header">
            <IconHeader
              variant="cardHeader"
              headerText="Complete your rollover"
            />
            <IconSubheader subheader="Follow these steps to send your rollover check to us." />
          </Modal.Header>
          <Modal.Body>{content}</Modal.Body>
          <Modal.Footer>
            <Button
              name="cancel"
              btnLabel="Done"
              onClick={() => this.props.onClose!()}
            />
          </Modal.Footer>
        </Modal>
      );
    }
    return null;
  }
}

export default withApollo<OwnProps>(PaychexRolloverInstructionsModal);
